import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bussiness-type',
  templateUrl: './bussiness-type.component.html',
  styleUrls: ['./bussiness-type.component.css']
})
export class BussinessTypeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
